import { Action } from '@ngrx/store';
import { ErpLayout } from '../../erp.model';

export enum LayoutActionTypes {
  SET_TASKS_FILTER = '[ERP LAYOUT] Set Task Filter',
  SET_SEARCH_VALUE_FILTER = '[ERP LAYOUT] Set Search Value Filter',
  SET_FILTERS_PANEL_STATUS = '[ERP LAYOUT] Set Filter Panel Status (mobile)',
}

export class SetTaskFilter implements Action {
  readonly type = LayoutActionTypes.SET_TASKS_FILTER;
  constructor(public payload: Partial<ErpLayout>) {}
}

export class SetSearchValueFilter implements Action {
  readonly type = LayoutActionTypes.SET_SEARCH_VALUE_FILTER;
  constructor(public payload: string) {}
}

export class SetFiltersPanelStatus implements Action {
  readonly type = LayoutActionTypes.SET_FILTERS_PANEL_STATUS;
  constructor(public payload: boolean) {}
}

export type LayoutActions = SetTaskFilter | SetSearchValueFilter | SetFiltersPanelStatus;
